import { addons } from '@storybook/addons';
import { create } from '@storybook/theming';

import logo from './logo.png';

const aha = 'rgb(1, 115, 207)';

addons.setConfig({
  theme: create({
    base: 'light',

    brandTitle: 'Aha! Component Library',
    brandUrl: 'https://www.aha.io',
    brandImage: logo,

    colorPrimary: aha,
    colorSecondary: aha,
  }),
});
